<template>
  <div class="book-menu">
    <h3 class="book-header">Books</h3>

    <router-link
      v-for="b in books"
      :key="b.to"
      :to="b.to"
      :class="linkClass(b.to)"
    >
      {{ b.label }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: "BookMenu",
  data() {
    return {
      books: [
        { label: "The House of Cavanaugh", to: "/books/thoc" },
        { label: "The Sweetheart Deal", to: "/books/tsd" },
        { label: "So Much a Part of You", to: "/books/smapoy" },
      ],
    };
  },
  methods: {
    linkClass(path) {
      // exact match (recommended for your setup)
      return this.$route.path === path ? "activeDropdown" : "dropdown";
    },
  },
};
</script>

<style scoped>
.book-menu {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-right: 1px solid var(--main-gray);
  padding-right: 1em;
  font-family: "Frank Ruhl Libre", serif;
}

.book-header {
  font-size: 1.5em;
  padding-bottom: 1em;
  padding-top: 0.25em;
  margin: 0;
  font-family: "Frank Ruhl Libre", serif;
  text-align: left;
}

.dropdown {
  color: black;
  text-decoration: none;
  margin-bottom: 0.5em;
  font-size: 1.15em;
}

.dropdown:hover {
  color: var(--main-accent);
}

.activeDropdown {
  color: var(--main-accent);
  text-decoration: none;
  margin-bottom: 0.5em;
  font-size: 1.15em;
}

@media (max-width: 768px) {
  .book-menu {
    border-right: none;
    border-bottom: 1px solid var(--secondary-gray);
    padding-right: 0;
    padding-bottom: 1em;
    margin-bottom: 1.5em;
    align-items: center;
    text-align: center;
  }
}
</style>
